import React, { useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
// import logo from "../../assets/icons/Kbr.png";
import logo from "../../assets/icons/KbrNew.png";
import "./login.css";
import md5 from "md5";
import { server_path } from "../../api/apiServices";
import { API } from "../../constants/APIConstant";

const LoginForm = ({ setIsLoggedIn, setUserName }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const hashedPassword = md5(password);

    const data = {
      username: email,
      password: hashedPassword,
    };

    try {
      const response = await fetch(`${server_path}${API.features_login}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();
      sessionStorage.setItem("accesstoken", responseData?.token);
      sessionStorage.setItem("userName", email.split("@")[0]);
      setUserName(() => email.split("@")[0]);
      setIsLoggedIn(true);
      setLoginError(false); // Reset login error state on successful login
      navigate("/");
    } catch (error) {
      setLoading(false);
      setLoginError(true); // Set login error state on API call failure
      console.error("Fetch error:", error);
    }

    setEmail("");
    setPassword("");
  };

  return (
    <div className="container">
      <div className="login-form">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={logo}
            // style={{ color: "black", backgroundColor: "rgb(24, 71, 101)" }}
            alt="Logo"
            width="120px"
            height="30px"
          />
        </div>
        <br />
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="formPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>

          {loginError && (
            <p style={{ color: "red" }}>Invalid username or password</p>
          )}
          <br />
          <Button
            variant="primary"
            type="submit"
            style={{ backgroundColor: "#004987" }}
          >
            Login &nbsp;
            {loading && <Spinner size="sm" />}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default LoginForm;
